// extracted by css-extract-rspack-plugin
module.exports =  {"root":"b241d0bd5c"};